module.exports = __webpack_public_path__ + "img/9788939206199.69080e2a.jpg";